import apiClient from '@/api/apiClient';
import { User, PaymentInfo } from '@/services/types';
import querystring from 'querystring';

class AuthService {
    //TODO: заменить any и return, когда будет готово API

    async login(payload): Promise<any> {
        return await fetch(`${process.env.VUE_APP_ACCOUNT_LOGIN_CHECK_URL}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: querystring.stringify(payload),
        })
            .then((response) => {
                // Auth success
                if (response.status === 200) return response.json();
                // Auth failed
                if (response.status === 400) return { status: response.status };
                /// Other
                return response;
            })
            .then((res) => {
                if (res.location) res.status = 200;
                return res;
            })
            .catch(function (err) {
                console.log(err);
            });
    }

    async getCurrentUser(payload): Promise<any> {
        const url: string = `/user`;
        const defaultValue = null;
        const errorPath: string = '[api:auth:getCurrentUser]';
        return await apiClient.user.get(url, defaultValue, errorPath, payload);
        // console.log(url, defaultValue, errorPath, payload);
        // return [null, {}];
    }

    async register(payload: User): Promise<any> {
        const url: string = `/user/register`;
        const defaultValue = null;
        const errorPath: string = '[api:auth:register]';
        //return await apiClient.user.post(url, defaultValue, errorPath, payload);
        console.log(url, defaultValue, errorPath, payload);
        return [null, {}];
    }

    async verificate(id: string, verificationCode: string): Promise<any> {
        const url: string = `/user/${id}/verificate`;
        const defaultValue = null;
        const errorPath: string = '[api:auth:verificate]';
        //return await apiClient.user.post(url, defaultValue, errorPath, { verificationCode });
        console.log(url, defaultValue, errorPath, verificationCode);
        return [null, {}];
    }

    async addPayment(id: string, payload: PaymentInfo): Promise<any> {
        const url: string = `/user/${id}/add-payment`;
        const defaultValue = null;
        const errorPath: string = '[api:auth:addPayment]';
        //return await apiClient.user.post(url, defaultValue, errorPath, payload);
        console.log(url, defaultValue, errorPath, payload);
        return [null, {}];
    }
    async checkIfCreated(id: string): Promise<any> {
        const url: string = `/user/${id}/isCreated`;
        const defaultValue = null;
        const errorPath: string = '[api:auth:isCreated]';
        //return await apiClient.user.get(url, defaultValue, errorPath);
        console.log(url, defaultValue, errorPath);
        return [null, {}];
    }

    async logout(id: string) {
        const url: string = `/user/${id}/logout`;
        const defaultValue = null;
        const errorPath: string = '[api:auth:logout]';
        // return await apiClient.user.post(url, defaultValue, errorPath, id);
        console.log(url, defaultValue, errorPath, id);
        return [null, {}];
    }

    async requestPasswordReset(email: string) {
        return await fetch(`${process.env.VUE_APP_ACCOUNT_API_URL}/reset-password-request`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        })
            .then((response) => {
                return response;
            })
            .catch(function (err) {
                console.log(err);
            });
    }

    async resetPassword(code: string, newPassword: string) {
        const url: string = `/reset-password`;
        const defaultValue = null;
        const errorPath: string = '[api:auth:resetPassword]';
        const data = { code, password: newPassword };
        return apiClient.guest.post(url, defaultValue, errorPath, data);
    }
}

export default new AuthService();
